import { TextField, TextFieldProps } from '@mui/material'
import { CleaveOptions } from 'cleave.js/options'
import { CleaveTextField } from '../CleaveTextField'

type Input = TextFieldProps & {
    options?: CleaveOptions
}

export default function ControlledTextField({
    value,
    InputProps,
    options,
    sx,
    ...props
}: Input) {
    return (
        <TextField
            {...props}
            SelectProps={{
                ...props.SelectProps,
                MenuProps: {
                    ...props.SelectProps?.MenuProps,
                    PaperProps: {
                        sx: {
                            maxHeight: '25rem',
                            ...props.SelectProps?.MenuProps?.sx,
                        },
                        ...props.SelectProps?.MenuProps?.PaperProps,
                    },
                },
            }}
            value={value ?? ''}
            fullWidth
            inputProps={{
                ...(props.inputProps ? props.inputProps : {}),
                ...(options ? { options } : {}),
            }}
            InputProps={{
                ...InputProps,
                ...(options
                    ? {
                          inputComponent: CleaveTextField as any,
                      }
                    : {}),
            }}
        />
    )
}
